import { render, staticRenderFns } from "./SettingsUnit.vue?vue&type=template&id=2a679395"
import script from "./SettingsUnit.vue?vue&type=script&lang=ts"
export * from "./SettingsUnit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports